export const GET_PHYSICAL_PERSON_ATTEMPT = 'GET_PHYSICAL_PERSON_ATTEMPT';
export type GET_PHYSICAL_PERSON_ATTEMPT = typeof GET_PHYSICAL_PERSON_ATTEMPT;

export const GET_PHYSICAL_PERSON_SUCCESS = 'GET_PHYSICAL_PERSON_SUCCESS';
export type GET_PHYSICAL_PERSON_SUCCESS = typeof GET_PHYSICAL_PERSON_SUCCESS;

export const GET_PHYSICAL_PERSON_FAILURE = 'GET_PHYSICAL_PERSON_FAILURE';
export type GET_PHYSICAL_PERSON_FAILURE = typeof GET_PHYSICAL_PERSON_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/physical-person/get/Types.tsx